import { Resolver } from "react-hook-form";
import { Auth } from "../models/entities/auth.model";

const resolver: Resolver<Auth> = async (values) => {
  if (!values.username) {
    return {
      errors: {
        login: {
          type: "required",
          message: "This field is required",
        },
      },
      values: {},
    };
  } else if (!values.password) {
    return {
      errors: {
        password: {
          type: "required",
          message: "This field is required",
        },
      },
      values: {},
    };
  }

  return {
    errors: {},
    values,
  };
};
export default resolver;
